import React from "react";
import { useLanguage } from "../../utils/languageContext.js";
import { getTranslation } from "../../utils/translate.js";
import Button from "../comman/button.js";
import Modal from "../comman/modal.js";

const ConfirmationModal = ({ description, onCancel, onSubmit }) => {
    const { language } = useLanguage();

    return (
        <Modal
            isOpen={true}
            onClose={onCancel}
            title={getTranslation('common.areYouSure', language)}
            size="sm"
        >
            <p className="mb-4 text-gray-700 dark:text-[#b1bac4] font-medium">{description}</p>
            <div className="flex justify-end gap-4">
                <Button
                    variant="secondary"
                    size="md"
                    onClick={onCancel}
                >
                    {getTranslation('common.cancel', language)}
                </Button>
                <Button
                    variant="primary"
                    size="md"
                    onClick={onSubmit}
                >
                    {getTranslation('common.confirm', language)}
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;